import React, { FunctionComponent, InputHTMLAttributes } from 'react';
import { UseFormMethods } from 'react-hook-form';
import TermsWrapper from 'Components/TermsWrapper';
import PasswordField from 'SharedComponents/PasswordField';
import EmailInput from 'SharedComponents/EmailInput';
import useTranslate from 'Hooks/useTranslate';
import { Step } from 'SharedComponents/styled/forms/Step';
import { Field } from 'SharedComponents/styled/forms/Field';
import AutoType from 'SharedComponents/AutoType';
import { AbTestVariant } from 'Interfaces/AbTestVariant';
import { useFeatureToggle } from 'AppShell/hooks';
import { StepStatus } from 'Interfaces/StepStatus';

interface StepOneProps {
    isFolded: boolean;
    isFormReady: boolean;
    setIsFolded: Function;
    isLoading: boolean;
    playEmailPlaceholderAnim: boolean;
    backendEmailValidator: Function;
    emailInputProps: InputHTMLAttributes<HTMLInputElement>;
    passwordInputProps: InputHTMLAttributes<HTMLInputElement>;
    formApi: UseFormMethods;
    showTerms: boolean;
    status?: StepStatus;
    errorCallback?: (this: HTMLInputElement, ev: Event) => void;
}

const EmailField: FunctionComponent<StepOneProps> = props => {
    const { tPlain } = useTranslate();
    return (
        <Field>
            <EmailInput
                data-testid="email-input"
                backendEmailValidator={props.backendEmailValidator}
                formApi={props.formApi}
                placeholder={props.playEmailPlaceholderAnim ? '' : tPlain('signupOverlay_Email placeholder')}
                readOnly={props.isLoading}
                autoFocus={props.isFormReady}
                errorCallback={props.errorCallback}
                {...props.emailInputProps}
            />
            {props.playEmailPlaceholderAnim && (
                <AutoType data-testid="email-auto-type">{tPlain('signupOverlay_Email placeholder')}</AutoType>
            )}
        </Field>
    );
};

const StepOne: FunctionComponent<StepOneProps> = props => {
    const { passwordlessVariant } = useFeatureToggle();
    const isPasswordless = passwordlessVariant === AbTestVariant.B;

    return (
        <Step status={props.status ?? StepStatus.PENDING}>
            <EmailField {...props} />
            {!isPasswordless && (
                <PasswordField
                    formApi={props.formApi}
                    isLoading={props.isLoading}
                    passwordInputProps={props.passwordInputProps}
                    isFolded={props.isFolded}
                />
            )}
            <TermsWrapper
                isVisible={props.showTerms && !props.isFolded}
                showError={!!props.formApi.errors.agb}
                usingRef={() => props.formApi.register({ required: true })}
                disabled={props.isLoading}
                onChange={() => props.formApi.clearErrors('agb')}
            />
        </Step>
    );
};

export default StepOne;
